import { render, staticRenderFns } from "./SocialMngSolutions.vue?vue&type=template&id=63ec6e6c&scoped=true"
import script from "./SocialMngSolutions.vue?vue&type=script&lang=js"
export * from "./SocialMngSolutions.vue?vue&type=script&lang=js"
import style0 from "./SocialMngSolutions.vue?vue&type=style&index=0&id=63ec6e6c&prod&lang=scss&scoped=true"
import style1 from "./SocialMngSolutions.vue?vue&type=style&index=1&id=63ec6e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec6e6c",
  null
  
)

export default component.exports